export default function deletePostMedia(state, action) {
  const nextState = { ...state };
  const { id, mediaKey } = action.payload || {};

  nextState[mediaKey] = nextState[mediaKey].filter(item => item.id !== id);

  return nextState;
}
